import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, CanLoad, Route } from '@angular/router';
import { JwtToken } from '../models/jwt-token';
import { CommonService } from './common.service';
import { JwtHelperService } from './jwt-helper.service';
import { UserService } from './user.service';

@Injectable({
    providedIn: 'root'
})
export class AuthGuard implements CanActivate {

    constructor(
        private router: Router, 
        private commonService: CommonService,
        public userService: UserService, 
        private jwtService: JwtHelperService
    ) { }

    async canActivate(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot): Promise<boolean> {
        let isAutherized: boolean = false;
        if (!this.userService.userDetails && localStorage.UserDetails) {
            this.userService.userDetails = JSON.parse(localStorage.UserDetails);
            this.userService.isAutherized = true;
        }
        if (!this.userService.userDetails) {
            isAutherized = false;
            try {
                let email = route.paramMap.get('userEmail');
                let response = null;
                response = await this.userService.windowsLogin(email ?? undefined);
                if (response && response.success) {
                    localStorage.removeItem("token");
                    var token = this.commonService.encrypt(response.token!)
                    console.log(token)
                    localStorage.setItem("token", token); 
                    isAutherized = true;
                }
                else if (response.message == "unsupported") {
                    this.router.navigate(['/unsupported'])
                }
                else {
                    this.userService.userDetails = undefined;
                    this.userService.isAutherized = false;
                    this.router.navigate(['/unauthorised'])
                }
            } catch (error) {
                this.userService.userDetails = undefined;
                this.userService.isAutherized = false;
                this.router.navigate(['/unauthorised'])
            }

        } else {
            return true;
        }
        return isAutherized;
    }
}
